import apiUrl from '../../../constants'
import axios from 'axios'
import {
    BasicSelect
} from 'vue-search-select';
import PageTracker from '../../../common/PageTrackerHelper';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Paginate from "vuejs-paginate";
import tableTemplate from '../common/table-template';
const moment = require('moment');
import DatePicker from 'vue2-datepicker';

export default {
    name: 'MisrouteRequestAssignee',
    components: {
        BasicSelect,
        Paginate,
        VueElementLoading,
        'load-table-template': tableTemplate,
        'date-picker': DatePicker,
    },
    mixins: [PageTracker],
    data: function () {
        return {
            fromdate: '',
            todate: '',
            ActiveTabIndex: 0,
            status: '',
            currentTab: '',
            currentScreenTab: 'WithinSLA',
            withinsla: "",
            loader: '<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
            CityLoader: '',
            City: '',
            Cityid: '',
            CityList: [],
            CityArrayList: [],
            CityObj: {
                value: "",
                text: ""
            },
            SVC: '',
            SVCList: [],
            SVCArrayList: [],
            SVCObj: {
                value: "",
                text: ""
            },
            SVCid: '',
            SVCLoader: '',
            MisrouteType: '',
            MisroutetypeList: [{
                    value: 1,
                    text: "Inter City"
                },
                {
                    value: 2,
                    text: "Intra City"
                },
            ],
            MisroutetypeObj: {},
            MisrouteReason: '',
            MisrouteReasonList: [],
            MisrouteReasonObj: {},
            Zone: '',
            Zoneid: '',
            ZoneList: [],
            ZoneArrList: [],
            ZoneObj: {
                value: "",
                text: ""
            },
            ZoneLoader: '',
            AWBNumbers: '',
            PendingAWBNumbers: '',
            AccAWBNumbers: '',
            RejAWBNumbers: '',
            validDateRangeFrom: null,
            todaysDate: null,
            txtCFDate: null,
            txtCTDate: null,
            selectedDtpFromDate: null,
            validDateRange: null,

            UnassignedColumns: [
                // {
                //     "label": 'AWB',
                //     "key": "shippingid"
                // },
                {
                    "label": 'Shipment Type',
                    "key": "shipmenttype"
                },
                {
                    "label": 'Misroute Type',
                    "key": "misroutetype"
                },
                {
                    "label": 'Misroute Reason',
                    "key": "misroutereason"
                },
                {
                    "label": 'Misroute Count',
                    "key": "misroutecount"
                },
                {
                    "label": 'Current City',
                    "key": "currenthubcity"
                },
                {
                    "label": 'Current Address',
                    "key": "currentaddress"
                },
                {
                    "label": 'Current Pincode',
                    "key": "currentpincode"
                },
                {
                    "label": 'Current SVC',
                    "key": "currenthub"
                },
                {
                    "label": 'Vendor Name',
                    "key": "vendorname"
                },
                {
                    "label": 'Suggested Pincode',
                    "key": "suggestedpincode"
                },
                {
                    "label": 'Suggested SVC',
                    "key": "suggestedhub"
                },
            ],
            isEditSeq: false,
            Shipmentloader: false,
            showShipmentsList: [],
            UnassignedTable: true,
            ShipmentCount: 0,
            Unpagecount: 0,
            PnPagecount: 0,
            accPagecount: 0,
            RejPagecount: 0,
            UnpageNo: 1,
            pnpageNo: 1,
            accpageNo: 1,
            rejpageNo: 1,
            PageLimit: 20,
            PendingMisrouteType: '',
            PendingMisroutetypeObj: {},
            PendingColumns: [
                // {
                //     "label": 'AWB',
                //     "key": "shippingid"
                // },
                {
                    "label": 'Shipment Type',
                    "key": "shipmenttype"
                },
                {
                    "label": 'Misroute Type',
                    "key": "misroutetype"
                },
                {
                    "label": 'Misroute Reason',
                    "key": "misroutereason"
                },
                {
                    "label": 'Misroute Count',
                    "key": "misroutecount"
                },
                {
                    "label": 'Current City',
                    "key": "currenthubcity"
                },
                {
                    "label": 'Current Address',
                    "key": "currentaddress"
                },
                {
                    "label": 'Current Pincode',
                    "key": "currentpincode"
                },
                {
                    "label": 'Current SVC',
                    "key": "currenthub"
                },
                {
                    "label": 'Vendor Name',
                    "key": "vendorname"
                },
                {
                    "label": 'Suggested Pincode',
                    "key": "suggestedpincode"
                },
                {
                    "label": 'Suggested SVC',
                    "key": "suggestedhub"
                },
            ],
            PendingTable: true,
            BulkActionModel: false,
            BulkAssignModel: false,
            User: '',
            UserList: [],
            UserArrList: [],
            UserLoader: false,
            UserObj: {
                value: "",
                text: ""
            },
            checkerid: '',
            AccMisroutetypeObj: {},
            AccMisrouteType: '',
            RejMisroutetypeObj: {},
            RejMisrouteType: '',
            AcceptedColumns: [
                // {
                //     "label": 'AWB',
                //     "key": "shippingid"
                // },
                {
                    "label": 'Shipment Type',
                    "key": "shipmenttype"
                },
                {
                    "label": 'Misroute Type',
                    "key": "misroutetype"
                },
                {
                    "label": 'Misroute Reason',
                    "key": "misroutereason"
                },
                {
                    "label": 'Misroute Count',
                    "key": "misroutecount"
                },
                {
                    "label": 'Current City',
                    "key": "currenthubcity"
                },
                {
                    "label": 'Current Address',
                    "key": "currentaddress"
                },
                {
                    "label": 'Current Pincode',
                    "key": "currentpincode"
                },
                {
                    "label": 'Current SVC',
                    "key": "currenthub"
                },
                {
                    "label": 'Vendor Name',
                    "key": "vendorname"
                },
                {
                    "label": 'Actual Pincode',
                    "key": "actualpincode"
                },
                {
                    "label": 'Actual SVC',
                    "key": "actualdestinationhub"
                },
                {
                    "label": 'Accepted By',
                    "key": "lastmodifiedby"
                },
            ],
            AcceptedTable: true,
            // Acpagecount: 0,
            RejectedColumns: [
                // {
                //     "label": 'AWB',
                //     "key": "shippingid"
                // },
                {
                    "label": 'Shipment Type',
                    "key": "shipmenttype"
                },
                {
                    "label": 'Misroute Type',
                    "key": "misroutetype"
                },
                {
                    "label": 'Misroute Reason',
                    "key": "misroutereason"
                },
                {
                    "label": 'Misroute Count',
                    "key": "misroutecount"
                },
                {
                    "label": 'Current City',
                    "key": "currenthubcity"
                },
                {
                    "label": 'Current Address',
                    "key": "currentaddress"
                },
                {
                    "label": 'Current Pincode',
                    "key": "currentpincode"
                },
                {
                    "label": 'Current SVC',
                    "key": "currenthub"
                },
                {
                    "label": 'Vendor Name',
                    "key": "vendorname"
                },
                {
                    "label": 'Suggested Pincode',
                    "key": "suggestedpincode"
                },
                {
                    "label": 'Suggested SVC',
                    "key": "suggestedhub"
                },
                {
                    "label": 'Rejected By',
                    "key": "lastmodifiedby"
                },
            ],
            RejectedTable: true,
            // Repagecount: 0,
            PendingMisrouteReasonObj: {},
            PendingMisrouteReason: '',
            AccMisrouteReasonObj: {},
            AccMisrouteReason: '',
            RejMisrouteReasonObj: {},
            RejMisrouteReason: '',
            PendingCityObj: {
                value: "",
                text: ""
            },
            PendingCity: '',
            PendingCityid: '',
            AccCityObj: {
                value: "",
                text: ""
            },
            AccCity: '',
            AccCityid: '',
            RejCityObj: {
                value: "",
                text: ""
            },
            RejCity: '',
            RejCityid: '',
            PendingSVCObj: {
                value: "",
                text: ""
            },
            PendingSVC: '',
            PendingSVCid: '',
            AccSVCObj: {
                value: "",
                text: ""
            },
            AccSVC: '',
            AccSVCid: '',
            RejSVCObj: {
                value: "",
                text: ""
            },
            RejSVC: '',
            RejSVCid: '',
            PendingZoneObj: {
                value: "",
                text: ""
            },
            PendingZone: '',
            PendingZoneid: '',
            AccZoneObj: {
                value: "",
                text: ""
            },
            AccZone: '',
            AccZoneid: '',
            RejZoneObj: {
                value: "",
                text: ""
            },
            RejZone: '',
            RejZoneid: '',
            selectedItemdata: [],
            selectedItems: [],
            checkerlistArr: [],
            selectedShipments: '',
            IsReload: false,
            AssignButton: false,
            BulkAssignButton: false,
            BulkActionButton: false,
            SubmitRequestModel: false,
            shipmentTypeObj: [],
            ReqShipmentType: '',
            ReqShipment: '',
            ReqVendorName: '',
            ReqVendorAddress: '',
            ReqCurrentAddress: '',
            ReqCurrentPincode: '',
            ReqCurrentDestSVC: '',
            ReqCurrentHubId: null,
            ReqReason: '',
            ReqsuggHubId: null,
            ReqsuggSVC: '',
            ReqsuggPincode: '',
            rejectionReason: '',
            ActualDestSVC: '',
            ActualPincode: '',
            selected: '',
            MapUrl: 'https://www.google.com/maps/embed/v1/place?key=AIzaSyDMiSqWKOWQEOTPBon5dMWP2F_sxkjYVSY&q=',
            defaultAddress: 'India',
            MapAddress: '',
            ActualDestHubId: null,
            rejectReasonObj : [],
            MarkShipmentStatus : "XBU00260",
            isResetLoad: false,
            BulkMisrouteinfoArr: [],
            IsMisrouteReqSE: false,
            dismissCountDown: 0,
            dismissSecs: 20,
            requestsErrorMsg: [],
            reqErrorCount: "",
            reqSuccessCount: "",
            AcceptReject:'',
            rejectReason: '',
            bulkAssignUser: false,
            currentActionTab: '',
            currentFiltersTab: 'clearFilters',
            slaBreachedCount: 0,
            withinSlaCount: 0,
            unAssTabShipCount: 0,
            pendignShipCount: 0,
            acceptedShipCount: 0,
            rejectedShipCount: 0,
            ShipmentTypeList: [{value: 1,text: "Delivery"},{value: 2,text: "RVP"},{value: 3,text: "RTO/DTO"}],
            ShipmentTypeObj: {},
            ShipmentType: '',
            PendingShipmentType: '',
            AccShipmentType: '',
            RejShipmentType: '',
            isRTODTO: false,
            RejectionCount: '',
            MisrouteCount: '',
            AssignedHubId: '',
            AssignedUserId: '',
            ReqCurrentCityId: '',
            raisedbyuserid: '',
            Currpincode: '',
            PendingCurrpincode: '',
            AccCurrpincode: '',
            RejCurrpincode: '',
            Vendorname: '',
            PendingVendorname: '',
            AccVendorname: '',
            RejVendorname: '',
            CurrPincodeList: [],
            VendorList: [],
            CurrpincodeObj: {text: ""},
            VendornameObj: {text: ""},
            VendorListLoader: '',
            CurrPincodeListLoader: '',
            SuggSVC: '',
            PendingSuggSVC: '',
            PendingSuggSVCid: '',
            AccSuggSVC: '',
            AccSuggSVCid: '',
            RejSuggSVC: '',
            RejSuggSVCid: '',
            SuggSVCObj: {value: "",text: ""},
            SuggSVCid: '',
            SuggSVCArrayList: [],
            SuggSVCList: [],
            SuggSVCLoader: '',
            PincodeList: [],
            PincodeListObj: {text: ""},
            BulkSPincode: null,
            mismatchedTypeShipments: [],
            mismatchedTypeError: '',
            IsAssignReqSE: false,
            moreShipmentsColumns:[
                {
                    "label": 'Shipment Type',
                    "key": "shipmenttype"
                },
                {
                    "label": 'Vendor Name',
                    "key": "vendorname"
                }
            ],
            sameReqShipModel: false,
            sameVendorShipList: [],
            MultiShipmentloader: false,
            requestId: '',
            ReqShipmentToShow: '',
            ReqShipmentsCount: 0,
            submitLoader: false,
            userDataKey : '',
            clientListLoader: false,       
            allClientsList: [],
            reqClientsListLoader: false,
            reqClientsList: [],
            reqClientObj: {text: "", value: ""},
            ClientId: null,
            PendingClientId: null,
            AccClientId: null,
            RejClientId: null,
        }
    },
    updated() {
        if(this.ActiveTabIndex == 0){
            $('.Planned-tabs a:first').addClass('active')
            if(this.currentScreenTab == 'SLABreached'){
                $('.Planned-tabs a:first').addClass('inactive')
            }
        }
    },
    async mounted() {
        this.userDataKey = window.localStorage.getItem('userUniqueKey');
        let validateUser = await this.validateJwtToken();
        var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext)
        this.createdBy = userdetail.username;
        this.userid = userdetail.userid;
        this.userHubId = userdetail.hubdetails[0] == undefined ? 0 : userdetail.hubdetails[0];
        this.status = "Unassigned";
        await this.getAllClientsList();
        // this.GetCurrentScreenValue();
        this.GetUserList();
        // this.getShipmentType();
        this.tabWiseShipmentsCount();
        this.SwitchTabs();
        this.getMisrouteReasonsByType();
    },
    methods: {
        tabTitle(title, count) {
            return `${title} (${count})</span>`;
        },

        //Function to get Within SLA or SLA Breached value
        async GetCurrentScreenValue(currentVal) {
            this.ShipmentCount = 0;
            this.withinsla = "1";
            this.currentScreenTab = currentVal;
            if (currentVal == 'WithinSLA') {
                this.withinsla = "1";
            } else if (currentVal == 'SLABreached') {
                this.withinsla = "0";
            }
            this.GetSVCList();
            this.GetZoneList();
            this.loadCityList();
            this.GetVendorList();
            await this.getRequestedClientIdsList();
            this.selectClient({}, true);
            this.GetCurrentPincodeList();
            this.GetSuggSVCList();
            this.tabWiseGetAndSearchData();
        },

        async switchBulkAssignOrAction(currentVal){
            this.currentActionTab = currentVal;
            if (currentVal == 'bulkAssignUser') {
                this.bulkAssignUser = true;
                this.GetUserList();
            } else if (currentVal == 'bulkReqAction') {
                this.IsAssignReqSE = false;
                this.mismatchedTypeError = '';
                this.reqErrorCount= "";
                this.reqSuccessCount= "";
                this.bulkAssignUser = false;
            }
        },

        async getCurrentFilterTabs(currentVal){
            this.currentFiltersTab = currentVal;
        },

        SwitchTabs(){
            if(this.ActiveTabIndex == 0){
                this.UnassignedTab();
                this.withinSLACountAPI();
                this.SLABreachedCountAPI();
            }
            else if(this.ActiveTabIndex == 1){
                this.PendingTab();
                this.withinSLACountAPI();
                this.SLABreachedCountAPI();
            }
            else if(this.ActiveTabIndex == 2){
                this.AcceptedTab();
                this.withinSLACountAPI();
                this.SLABreachedCountAPI();
            }
            else if(this.ActiveTabIndex == 3){
                this.RejectedTab();
                this.withinSLACountAPI();
                this.SLABreachedCountAPI();
            }
        },

        tabWiseShipmentsCount(){
            let Payload = {
                "isAssignee": true
            }

            axios({
                method: 'POST',
                url: apiUrl.api_url + 'misroute/general/getcountagainststatus',
                data: Payload
            })
            .then(result => {
                if (result.data.code == 200) {
                    this.unAssTabShipCount = result.data.data.unAssignedCount;
                    this.pendignShipCount = result.data.data.pendingCount;
                    this.acceptedShipCount = result.data.data.acceptedCount;
                    this.rejectedShipCount = result.data.data.rejectedCount;
                }
                else{
                    this.unAssTabShipCount = 0;
                    this.pendignShipCount = 0;
                    this.acceptedShipCount = 0;
                    this.rejectedShipCount = 0;
                }
            })
            .catch((httpException) => {
                this.$alertify.error("Data not found.!");
                console.error('exception is:::::::::', httpException)
            })
        },

        //api call for withinSla Count...
        withinSLACountAPI(){
            this.withinSlaCount = 0;
            let payload = {
                withinsla: '1',
                limit: '40',
                pageno: '1',
            }
            if(this.ActiveTabIndex == 0){
                payload.status= 'Unassigned';
            }
            if(this.ActiveTabIndex == 1){
                payload.status= 'Pending';
            }
            if(this.ActiveTabIndex == 2){
                payload.status= 'Accepted';
            }
            if(this.ActiveTabIndex == 3){
                payload.status= 'Rejected';
            }

            axios({
                method: 'POST',
                url: apiUrl.api_url + 'misroute/assignee/getshipmentswithstatus',
                data: payload
            })
            .then(result => {
                if (result.data.code == 200) {
                    this.withinSlaCount = result.data.data.count;
                    try {
                        let TrackerInfo = {
                            projectname: "Last Mile",
                            type: "Web",
                            routeurl: "misroute/assignee/getshipmentswithstatus",
                            userid: this.userid,
                            username: this.createdBy,
                            meta: {
                                event: "misroute-assignee-getshipmentswithstatus",
                                shipmentId: null,
                                remarks: "FrontEnd",
                                hubId: this.userHubId ? this.userHubId : null
                            },
                        };
                        Object.assign(TrackerInfo.meta, payload);
                        this.PageTracker(TrackerInfo);
                    } catch (error) {
                        console.log(error);
                    }
                }
                else{
                    this.withinSlaCount = 0;
                }
            })
            .catch((httpException) => {
                this.$alertify.error("Data not found.!");
                console.error('exception is:::::::::', httpException)
            })
        },

        //api call for slabreached count...
        SLABreachedCountAPI(){
            this.slaBreachedCount = 0;
            let payload = {
                withinsla: '0',
                limit: '40',
                pageno: '1',
            }
            if(this.ActiveTabIndex == 0){
                payload.status= 'Unassigned';
            }
            if(this.ActiveTabIndex == 1){
                payload.status= 'Pending';
            }
            if(this.ActiveTabIndex == 2){
                payload.status= 'Accepted';
            }
            if(this.ActiveTabIndex == 3){
                payload.status= 'Rejected';
            }

            axios({
                method: 'POST',
                url: apiUrl.api_url + 'misroute/assignee/getshipmentswithstatus',
                data: payload
            })
            .then(result => {
                if (result.data.code == 200) {
                    this.slaBreachedCount = result.data.data.count;
                    try {
                        let TrackerInfo = {
                            projectname: "Last Mile",
                            type: "Web",
                            routeurl: "misroute/assignee/getshipmentswithstatus",
                            userid: this.userid,
                            username: this.createdBy,
                            meta: {
                                event: "misroute-assignee-getshipmentswithstatus",
                                remarks: "FrontEnd",
                                shipmentId: null,
                                hubId: this.userHubId ? this.userHubId : null
                            },
                        };
                        Object.assign(TrackerInfo.meta, payload);
                        this.PageTracker(TrackerInfo);
                    } catch (error) {
                        console.log(error);
                    }
                }
                else{
                    this.slaBreachedCount = 0;
                }
            })
            .catch((httpException) => {
                this.$alertify.error("Data not found.!");
                console.error('exception is:::::::::', httpException)
            })
        },

        async getMisrouteReasonsByType(){
            let ReasonList1 = await this.getMisrouteReasonForDelRVP();
            let ReasonList2 = await this.getMisrouteReasonForRTODTO();
            let combinationArr = ReasonList1.concat(ReasonList2);
            let uniqueObject = {};
            for (let i in combinationArr) {
                // Extract the text
                let objText = combinationArr[i]['text'];
                // Use the text as the index
                uniqueObject[objText] = combinationArr[i];
            }
            let FinalReasonList = [];
            for (let i in uniqueObject) {
                FinalReasonList.push(uniqueObject[i]);
            }
            this.MisrouteReasonList = FinalReasonList;
        },

        getMisrouteReasonForDelRVP(){
            return new Promise( (resolve, reject) => {
              let reasonList = [];
              axios.post(apiUrl.api_url + 'shipmentmisroute/reasondetailsbytype', {"ReasonType": "MarkMisroute"})
              .then((response) => {
                if(response.data.code===200){
                  let resLength = response.data.data.length;
                  for (let i = 0; i < resLength; i++) {
                    reasonList.push({
                      value: response.data.data[i].ReasonsID,
                      text: `${response.data.data[i].Reason}`,
                    });
                  }
                }
                else {
                  this.reasonList = [];
                }
                resolve(reasonList);
              })
              .catch((httpException) => {
                this.$alertify.error("Failed to load misroute reasons.!");
                console.error('exception is:::::::::', httpException)
              })
            })
        },

        getMisrouteReasonForRTODTO(){
            return new Promise( (resolve, reject) => {
                let reasonList = [];
                axios.post(apiUrl.api_url + 'shipmentmisroute/reasondetailsbytype', {"ReasonType": "MarkVendorMisroute"})
                .then((response) => {
                if(response.data.code===200){
                    let resLength = response.data.data.length;
                    for (let i = 0; i < resLength; i++) {
                    reasonList.push({
                        value: response.data.data[i].ReasonsID,
                        text: `${response.data.data[i].Reason}`,
                    });
                    }
                }
                else {
                    reasonList = [];
                }
                resolve(reasonList);
                })
                .catch((httpException) => {
                this.$alertify.error("Failed to load misroute reasons.!");
                console.error('exception is:::::::::', httpException)
                })
            })
        },

        async getRejectionReasonByType(isRtoDto){
            if(isRtoDto == false){
                this.rejectReasonObj = await this.getRejectionReasonForDelRVP();
            }
            else if(isRtoDto == true){
                this.rejectReasonObj = await this.getRejectionReasonForRTODTO();
            }
            else{
                let ReasonList1 = await this.getRejectionReasonForDelRVP();
                let ReasonList2 = await this.getRejectionReasonForRTODTO();
                let combinationArr = ReasonList1.concat(ReasonList2);
                let uniqueObject = {};
                for (let i in combinationArr) {
                    // Extract the text
                    let ReasonObj = combinationArr[i]['Reason'];
                    // Use the text as the index
                    uniqueObject[ReasonObj] = combinationArr[i];
                }
                let FinalReasonList = [];
                for (let i in uniqueObject) {
                    FinalReasonList.push(uniqueObject[i]);
                }
                this.rejectReasonObj = FinalReasonList;
            }
        },

        getRejectionReasonForDelRVP(){
            return new Promise( (resolve, reject) => {
                let reasonObj = [];
                axios.post(apiUrl.api_url + 'shipmentmisroute/reasondetailsbytype', {"ReasonType": "RejectMisroute"})
                .then((response) => {
                    if(response.data.code===200){
                        let resLength = response.data.data.length;
                        for (let i = 0; i < resLength; i++) {
                            reasonObj.push(response.data.data[i]);
                        }
                    }
                    else {
                        this.reasonObj = [];
                    }
                    resolve(reasonObj);
                })
                .catch((httpException) => {
                    this.$alertify.error("Failed to load rejection reasons.!");
                    console.error('exception is:::::::::', httpException)
                })
            })
        },

        getRejectionReasonForRTODTO(){
            return new Promise( (resolve, reject) => {
                let reasonObj = [];
                axios.post(apiUrl.api_url + 'shipmentmisroute/reasondetailsbytype', {"ReasonType": "RejectVendorMisroute"})
                .then((response) => {
                    if(response.data.code===200){
                        let resLength = response.data.data.length;
                        for (let i = 0; i < resLength; i++) {
                            reasonObj.push(response.data.data[i]);
                        }
                    }
                    else {
                        reasonObj = [];
                    }
                    resolve(reasonObj);
                })
                .catch((httpException) => {
                    this.$alertify.error("Failed to load rejection reasons.!");
                    console.error('exception is:::::::::', httpException)
                })
            })
        },

        UnassignedTab() {
            this.Reset1();
            this.status = "Unassigned"
            this.withinsla = 1;
            this.GetCurrentScreenValue('WithinSLA');
            // this.UnassignedTableList();
        },
        PendingTab() {
            this.Reset1()
            this.status = "Pending"
            this.withinsla = 1;
            this.GetCurrentScreenValue('WithinSLA');
            this.IsReload = true;
            // this.PendingTableList();
        },
        AcceptedTab() {
            this.Reset1()
            this.status = "Accepted"
            this.withinsla = 1;
            this.GetCurrentScreenValue('WithinSLA');
            this.IsReload = true;
            // this.AcceptedTableList();
        },
        RejectedTab() {
            this.Reset1();
            this.status = "Rejected"
            this.withinsla = 1;
            this.GetCurrentScreenValue('WithinSLA');
            this.IsReload = true;
            // this.RejectedTableList();
        },
        //AWB Validations
        onlyNumber: function ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 8 && keyCode !== 44) {
                $event.preventDefault();
            }
        },
        //FromDate ToDate validations
        checkToDate() {
            this.txtCTDate = '';
            this.todaysDate = moment().format('YYYY-MM-DD');
            this.selectedDtpFromDate = moment.utc(this.txtCFDate).format("YYYY-MM-DD").valueOf();
            this.txtCTDate = this.txtCFDate;
            if (this.txtCFDate > this.todaysDate) {
                this.$alertify.error("Please select less than todays date")
                this.txtCFDate = null;
            } else {
                this.validDateRange = this.selectedDtpFromDate
            }
        },
        checkFromDate() {
            this.validDateRangeFrom = moment.utc(this.txtCTDate).format("YYYY-MM-DD").valueOf();
            if (this.txtCTDate > this.todaysDate) {
                this.$alertify.error("Please select less than todays date")
                this.txtCTDate = null;
            }
        },
        //Get City List
        loadCityList() {
            this.CityLoader = this.loader
            this.CityArrayList = []
            this.CityList = []
            this.input = {
                "status": this.status,
                "withinsla": this.withinsla
            }
            axios({
                method: 'POST',
                url: apiUrl.api_url + 'misroute/general/getcitylistfromtargetscreen',
                data: this.input
            })
            .then(result => {
                if (result.data.code == 200) {
                    this.CityArrayList = result.data.data;
                    for (var i = 0; i < this.CityArrayList.length; i++) {
                        this.CityList.push({
                            value: this.CityArrayList[i].cityid,
                            text: `${this.CityArrayList[i].cityname} `,
                        })
                    }
                }
                this.CityLoader = ''
            }, error => {
                this.CityLoader = ''
                console.error(error)
            })
        },

        selectCity(obj) {
            this.CityObj = obj;
            if(this.ActiveTabIndex == 0){
                this.City = obj.text;
                this.Cityid = obj.value;
            }
            if(this.ActiveTabIndex == 1){
                this.PendingCity = obj.text;
                this.PendingCityid = obj.value;
            }
            if(this.ActiveTabIndex == 2){
                this.AccCity = obj.text;
                this.AccCityid = obj.value;
            }
            if(this.ActiveTabIndex == 3){
                this.RejCity = obj.text;
                this.RejCityid = obj.value;
            }
            this.tabWiseGetAndSearchData();
        },

        //Get SVC List
        GetSVCList() {
            this.SVCLoader = this.loader
            this.SVCArrayList = []
            this.SVCList = []
            this.input = {
                "status": this.status,
                "withinsla": this.withinsla
            }
            axios({
                method: 'POST',
                url: apiUrl.api_url + 'misroute/general/getsvclistfromtargetscreen',
                data: this.input
            })
            .then(result => {
                if (result.data.code == 200) {
                    this.SVCArrayList = result.data.data;
                    for (var i = 0; i < this.SVCArrayList.length; i++) {
                        this.SVCList.push({
                            value: this.SVCArrayList[i].hubid,
                            text: `${this.SVCArrayList[i].hubname} `,
                        })
                    }
                }
                this.SVCLoader = ''
            }, error => {
                this.SVCLoader = ''
                console.error(error)
            })
        },

        selectSVC(obj) {
            this.SVCObj = obj;
            if(this.ActiveTabIndex == 0){
                this.SVC = obj.text;
                this.SVCid = obj.value;
            }
            if(this.ActiveTabIndex == 1){
                this.PendingSVC = obj.text;
                this.PendingSVCid = obj.value;
            }
            if(this.ActiveTabIndex == 2){
                this.AccSVC = obj.text;
                this.AccSVCid = obj.value;
            }
            if(this.ActiveTabIndex == 3){
                this.RejSVC = obj.text;
                this.RejSVCid = obj.value;
            }
            this.tabWiseGetAndSearchData();
        },

        //Get SVC List
        GetSuggSVCList() {
            this.SuggSVCLoader = this.loader
            this.SuggSVCArrayList = []
            this.SuggSVCList = []
            this.input = {
                "status": this.status,
                "withinsla": this.withinsla
            }
            axios({
                method: 'POST',
                url: apiUrl.api_url + 'misroute/general/getsuggestedsvclist',
                data: this.input
            })
            .then(result => {
                if (result.data.code == 200) {
                    this.SuggSVCArrayList = result.data.data;
                    for (var i = 0; i < this.SuggSVCArrayList.length; i++) {
                        this.SuggSVCList.push({
                            value: this.SuggSVCArrayList[i].suggestedHubId,
                            text: `${this.SuggSVCArrayList[i].suggestedHubName} `,
                        })
                    }
                }
                this.SuggSVCLoader = ''
            }, error => {
                this.SuggSVCLoader = ''
                console.error(error)
            })
        },

        selectSuggestedSVC(obj) {
            this.SuggSVCObj = obj;
            if(this.ActiveTabIndex == 0){
                this.SuggSVC = obj.text;
                this.SuggSVCid = obj.value;
            }
            if(this.ActiveTabIndex == 1){
                this.PendingSuggSVC = obj.text;
                this.PendingSuggSVCid = obj.value;
            }
            if(this.ActiveTabIndex == 2){
                this.AccSuggSVC = obj.text;
                this.AccSuggSVCid = obj.value;
            }
            if(this.ActiveTabIndex == 3){
                this.RejSuggSVC = obj.text;
                this.RejSuggSVCid = obj.value;
            }
            this.tabWiseGetAndSearchData();
        },

        selectShipmentType(obj) {
            this.ShipmentTypeObj = obj;
            if(this.ActiveTabIndex == 0){
                this.ShipmentType = obj.text;
                this.isRTODTO = (this.ShipmentType == 'RTO/DTO') ? true : false;
            }
            if(this.ActiveTabIndex == 1){
                this.PendingShipmentType = obj.text
            }
            if(this.ActiveTabIndex == 2){
                this.AccShipmentType = obj.text
            }
            if(this.ActiveTabIndex == 3){
                this.RejShipmentType = obj.text
            }
            this.tabWiseGetAndSearchData();
        },

        GetCurrentPincodeList() {
            this.CurrPincodeListLoader = this.loader
            this.CurrPincodeList = []
            this.input = {
                "status": this.status,
                "withinsla": this.withinsla,
            }
            axios({
                    method: 'POST',
                    url: apiUrl.api_url + 'misroute/general/getcurrentpincodelist',
                    data: this.input
                })
                .then(result => {
                    if (result.data.code == 200) {
                        let CurrPincodeArrayList = result.data.data;
                        for (var i = 0; i < CurrPincodeArrayList.length; i++) {
                            this.CurrPincodeList.push({
                                text: `${CurrPincodeArrayList[i]} `,
                            })
                        }
                    }
                    this.CurrPincodeListLoader = ''
                }, error => {
                    this.CurrPincodeListLoader = ''
                    console.error(error)
                })
        },

        selectCurrPincode(obj) {
            this.CurrpincodeObj = obj;
            if(this.ActiveTabIndex == 0){
                this.Currpincode = obj.text.trim()
            }
            if(this.ActiveTabIndex == 1){
                this.PendingCurrpincode = obj.text.trim()
            }
            if(this.ActiveTabIndex == 2){
                this.AccCurrpincode = obj.text.trim()
            }
            if(this.ActiveTabIndex == 3){
                this.RejCurrpincode = obj.text.trim()
            }
            this.tabWiseGetAndSearchData();
        },

        GetVendorList() {
            this.VendorListLoader = this.loader
            this.VendorList = []
            this.input = {
                "status": this.status,
                "withinsla": this.withinsla,
            }
            axios({
                method: 'POST',
                url: apiUrl.api_url + 'misroute/general/getvendorslist',
                data: this.input
            })
            .then(result => {
                if (result.data.code == 200) {
                    let VendorArrayList = result.data.data;
                    for (var i = 0; i < VendorArrayList.length; i++) {
                        let target = /-|_|@|#/g;
                        let replacedVendorString = VendorArrayList[i].replaceAll(target, (match) => match + ' ');
                        this.VendorList.push({
                            text: `${replacedVendorString} `,
                            value: VendorArrayList[i]
                        })
                    }
                }
                this.VendorListLoader = ''
            }, error => {
                this.VendorListLoader = ''
                console.error(error)
            })
        },

        selectVendorName(obj) {
            this.VendornameObj = obj;
            if(this.ActiveTabIndex == 0){
                this.Vendorname = obj.value.trim()
            }
            if(this.ActiveTabIndex == 1){
                this.PendingVendorname = obj.value.trim()
            }
            if(this.ActiveTabIndex == 2){
                this.AccVendorname = obj.value.trim()
            }
            if(this.ActiveTabIndex == 3){
                this.RejVendorname = obj.value.trim()
            }
            this.tabWiseGetAndSearchData();
        },

        async getRequestedClientIdsList(){
            this.reqClientsListLoader = this.loader;
            this.reqClientsList = [];
            return axios({
                method: 'POST',
                url: apiUrl.api_url + 'misroute/general/get-req-clientslist',
                data: this.input
            })
            .then(result => {
                if (result.data.code == 200) {
                    let reqClientArrayList = result.data.data;
                    let filteredCientList = this.allClientsList.filter(client =>
                        reqClientArrayList.includes(client.ClientMasterID)
                    );
                    for (var i = 0; i < filteredCientList.length; i++) {
                        this.reqClientsList.push({
                            text: `${filteredCientList[i].CompanyName}`,
                            value: filteredCientList[i].ClientMasterID
                        })
                    }
                }
                this.reqClientsListLoader = ''
            }, error => {
                this.reqClientsListLoader = ''
                console.error('Error while loading client list :: ',error.message)
            })
        },

        selectClient(obj, isAutoSelect = false){
            if(isAutoSelect){
                this.reqClientObj = this.reqClientObj;
                if(this.ActiveTabIndex == 0){
                    this.ClientId = this.ClientId;
                }
                if(this.ActiveTabIndex == 1){
                    this.PendingClientId = this.PendingClientId;
                }
                if(this.ActiveTabIndex == 2){
                    this.AccClientId = this.AccClientId;
                }
                if(this.ActiveTabIndex == 3){
                    this.RejClientId = this.RejClientId;
                }
                this.tabWiseGetAndSearchData();    
            } else{
                this.reqClientObj = obj;
                if(this.ActiveTabIndex == 0){
                    this.ClientId = obj.value;
                }
                if(this.ActiveTabIndex == 1){
                    this.PendingClientId = obj.value;
                }
                if(this.ActiveTabIndex == 2){
                    this.AccClientId = obj.value;
                }
                if(this.ActiveTabIndex == 3){
                    this.RejClientId = obj.value;
                }
                this.tabWiseGetAndSearchData();
            }
        },

        //Get misroute Type List
        selectMisrouteType(obj) {
            this.MisroutetypeObj = obj;
            if(this.ActiveTabIndex == 0){
                this.MisrouteType = obj.text;
            }
            if(this.ActiveTabIndex == 1){
                this.PendingMisrouteType = obj.text
            }
            if(this.ActiveTabIndex == 2){
                this.AccMisrouteType = obj.text
            }
            if(this.ActiveTabIndex == 3){
                this.RejMisrouteType = obj.text
            }
            this.tabWiseGetAndSearchData();
        },

        //Get misroute Reason List
        selectMisrouteReason(obj) {
            this.MisrouteReasonObj = obj;
            if(this.ActiveTabIndex == 0){
                this.MisrouteReason = obj.text
            }
            if(this.ActiveTabIndex == 1){
                this.PendingMisrouteReason = obj.text
            }
            if(this.ActiveTabIndex == 2){
                this.AccMisrouteReason = obj.text
            }
            if(this.ActiveTabIndex == 3){
                this.RejMisrouteReason = obj.text
            }
            this.tabWiseGetAndSearchData();
        },

        //Get Zone List
        GetZoneList() {
            this.ZoneLoader = this.loader
            this.ZoneArrList = []
            this.ZoneList = []
            this.input = {
                "status": this.status,
                "withinsla": this.withinsla
            }
            axios({
                    method: 'POST',
                    url: apiUrl.api_url + 'misroute/general/getzonelistfromtargetscreen',
                    data: this.input
                })
                .then(result => {
                    if (result.data.code == 200) {
                        this.ZoneArrList = result.data.data;
                        for (var i = 0; i < this.ZoneArrList.length; i++) {
                            this.ZoneList.push({
                                value: this.ZoneArrList[i].zoneid,
                                text: `${this.ZoneArrList[i].zonename} `,
                            })
                        }
                    }
                    this.ZoneLoader = ''
                }, error => {
                    this.ZoneLoader = ''
                    console.error(error)
                })
        },

        selectZone(obj) {
            this.ZoneObj = obj;
            if(this.ActiveTabIndex == 0){
                this.Zone = obj.text;
                this.Zoneid = obj.value;
            }
            if(this.ActiveTabIndex == 1){
                this.PendingZone = obj.text;
                this.PendingZoneid = obj.value;
            }
            if(this.ActiveTabIndex == 2){
                this.AccZone = obj.text;
                this.AccZoneid = obj.value;
            }
            if(this.ActiveTabIndex == 3){
                this.RejZone = obj.text;
                this.RejZoneid = obj.value;
            }
            this.tabWiseGetAndSearchData();
        },

        selectUser(obj) {
            this.UserObj = obj;
            this.User = obj.text;
            this.checkerid = obj.value;
            this.checkerlistArr.map(obj => {
                obj.checkerid = this.checkerid
            })
        },

        GetUserList() {
            this.UserLoader = this.loader
            this.UserArrList = []
            this.UserList = []
            axios({
                    method: 'POST',
                    url: apiUrl.api_url + 'misroute/assignee/getcheckerlist',
                })
                .then(result => {
                    if (result.data.code == 200) {
                        this.UserArrList = result.data.data;
                        if(this.BulkAssignModel != true){
                            let dummyUser = {
                                "checkerid": 0,
                                "checkername": "-- Select User --"
                            }
                            this.UserArrList.push(dummyUser);
                        }
                        for (var i = this.UserArrList.length - 1; i >=0; i--) {
                            this.UserList.push({
                                value: this.UserArrList[i].checkerid,
                                text: `${this.UserArrList[i].checkername} `,
                            })
                        }
                    } else {
                        this.$alertify.error(result.data.message)
                    }
                    this.UserLoader = '';
                }, error => {
                    this.UserLoader = ''
                    console.error(error)
                })
        },

        async getAllClientsList() {
            this.allClientsList = [];
            return axios.get(apiUrl.api_url + 'external/getclientlist', {})
            .then((response) => {
                this.allClientsList = response.data.code == 200 ? response.data.data : [];
            })
            .catch((httpException) => {
                this.$alertify.error("client data not found");
                console.error('exception is:::::::::', httpException)
            })
        },

        //Common Table data Function
        CommonGetTableDetails(payload) {
            this.checkerlistArr = [];
            this.selectedItems = [];
            axios({
                method: 'POST',
                url: apiUrl.api_url + 'misroute/assignee/getshipmentswithstatus',
                data: payload
            })
            .then(result => {
                if (result.data.code == 200) {
                    this.showShipmentsList = result.data.data.rows;
                    this.ShipmentCount = result.data.data.count;
                    let singleReqCount = result.data.data.specificcount.withoutrequest;
                    let bulkReqCount = result.data.data.specificcount.withrequest;
                    let MaxCount = Math.max(singleReqCount,bulkReqCount);
                    if (this.ActiveTabIndex == 0) {
                        this.Unpagecount = Math.ceil(MaxCount / this.PageLimit);
                    } else if (this.ActiveTabIndex == 1) {
                        this.PnPagecount = Math.ceil(MaxCount / this.PageLimit);
                    } else if (this.ActiveTabIndex == 2) {
                        this.accPagecount = Math.ceil(MaxCount / this.PageLimit);
                    } else if (this.ActiveTabIndex == 3) {
                        this.RejPagecount = Math.ceil(MaxCount / this.PageLimit);
                    }
                    try {
                        let TrackerInfo = {
                            projectname: "Last Mile",
                            type: "Web",
                            routeurl: "misroute/assignee/getshipmentswithstatus",
                            userid: this.userid,
                            username: this.createdBy,
                            meta: {
                                event: "misroute-assignee-getshipmentswithstatus",
                                shipmentId: payload ? (payload.shippingids ? payload.shippingids[0] : null) : null,
                                remarks: "FrontEnd",
                                hubId: this.userHubId ? this.userHubId : null
                            },
                        };
                        Object.assign(TrackerInfo.meta, payload);
                        this.PageTracker(TrackerInfo);
                    } catch (error) {
                        console.log(error);
                    }
                } else {
                    this.ShipmentCount = 0;
                    if (this.ActiveTabIndex == 0) {
                        this.Unpagecount = 1;
                    } else if (this.ActiveTabIndex == 1) {
                        this.PnPagecount = 1;
                    } else if (this.ActiveTabIndex == 2) {
                        this.accPagecount = 1;
                    } else if (this.ActiveTabIndex == 3) {
                        this.RejPagecount = 1;
                    }
                    // this.$alertify.error(result.data.message)
                }
                this.IsReload = false;
                this.Shipmentloader = false;
            }, error => {
                this.Shipmentloader = false;
                console.error(error)
            })
        },

        tabWiseGetAndSearchData(){
            this.IsReload = true;
            this.BulkAssignButton = false;
            this.BulkActionButton = false;
            if(this.ActiveTabIndex == 0){
                this.UnpageNo = 1;
                this.$refs.UnAsspaginate.selected= 0;
                this.UnassignedTableList();
            }
            else if(this.ActiveTabIndex == 1){
                this.pnpageNo = 1;
                this.$refs.Pendingpaginate.selected= 0;
                this.PendingTableList();
            }
            else if(this.ActiveTabIndex == 2){
                this.accpageNo = 1;
                this.$refs.Accpaginate.selected= 0;
                this.AcceptedTableList();
            }
            else if(this.ActiveTabIndex == 3){
                this.rejpageNo = 1;
                this.$refs.Rejpaginate.selected= 0;
                this.RejectedTableList();
            }
        },
        //get Unassigned Table data
        UnassignedTableList() {
            this.Unpagecount = 0;
            this.UnassignedTable = true;
            this.Shipmentloader = true;
            this.showShipmentsList = [];
            let Filters = {
                cityid: this.Cityid,
                hubid: this.SVCid,
                misroutereason: this.MisrouteReason,
                misroutetype: this.MisrouteType.toLowerCase(),
                zoneid: this.Zoneid,
                shipmenttype: this.ShipmentType,
                currentpincode: this.Currpincode,
                vendorname: this.Vendorname,
                suggestedhubid: this.SuggSVCid,
                clientid: this.ClientId
            }
            let payload = {
                status: this.status,
                withinsla: this.withinsla.toString(),
                filters: Filters,
                fromdate: this.txtCFDate,
                todate: this.txtCTDate,
                limit: '40',
                pageno: this.UnpageNo,
            }
            if (this.AWBNumbers != "") {
                let shipingID = this.AWBNumbers.split(/[\s,]+/);
                let shipmentReqArray = [];
                $.each(shipingID, (key, AWBNumbers) => {
                    if (AWBNumbers != '') {
                        shipmentReqArray.push(AWBNumbers.trim())
                    }
                })
                payload.shippingids = shipmentReqArray;
            }
            this.CommonGetTableDetails(payload);
        },
        //get Pending Table data
        PendingTableList() {
            this.PnPagecount = 0;
            this.PendingTable = true;
            this.Shipmentloader = true;
            this.showShipmentsList = [];
            let Filters = {
                cityid: this.PendingCityid,
                hubid: this.PendingSVCid,
                misroutereason: this.PendingMisrouteReason,
                misroutetype: this.PendingMisrouteType.toLowerCase(),
                zoneid: this.PendingZoneid,
                shipmenttype: this.PendingShipmentType,
                currentpincode: this.PendingCurrpincode,
                vendorname: this.PendingVendorname,
                suggestedhubid: this.PendingSuggSVCid,
                clientid: this.PendingClientId
            }
            let payload = {
                status: this.status,
                withinsla: this.withinsla.toString(),
                filters: Filters,
                fromdate: this.txtCFDate,
                todate: this.txtCTDate,
                limit: '40',
                pageno: this.pnpageNo,
            }
            if (this.PendingAWBNumbers != "") {
                let shipingID = this.PendingAWBNumbers.split(/[\s,]+/);
                let shipmentReqArray = [];
                $.each(shipingID, (key, PendingAWBNumbers) => {
                    if (AWBNumbers != '') {
                        shipmentReqArray.push(PendingAWBNumbers.trim())
                    }
                })
                payload.shippingids = shipmentReqArray;
            }
            this.CommonGetTableDetails(payload);
            this.PendingTable = false;
        },
        // get Accepted Table data
        AcceptedTableList() {
            this.accPagecount = 0;
            this.AcceptedTable = true;
            this.Shipmentloader = true;
            this.showShipmentsList = [];
            let Filters = {
                cityid: this.AccCityid,
                hubid: this.AccSVCid,
                misroutereason: this.AccMisrouteReason,
                misroutetype: this.AccMisrouteType.toLowerCase(),
                zoneid: this.AccZone,
                shipmenttype: this.AccShipmentType,
                currentpincode: this.AccCurrpincode,
                vendorname: this.AccVendorname,
                suggestedhubid: this.AccSuggSVCid,
                clientid: this.AccClientId
            }
            let payload = {
                status: this.status,
                withinsla: this.withinsla.toString(),
                filters: Filters,
                fromdate: this.txtCFDate,
                todate: this.txtCTDate,
                limit: '40',
                pageno: this.accpageNo,
            }
            if (this.AccAWBNumbers != "") {
                let shipingID = this.AccAWBNumbers.split(/[\s,]+/);
                let shipmentReqArray = [];
                $.each(shipingID, (key, AccAWBNumbers) => {
                    if (AccAWBNumbers != '') {
                        shipmentReqArray.push(AccAWBNumbers.trim())
                    }
                })
                payload.shippingids = shipmentReqArray;
            }
            this.CommonGetTableDetails(payload);
            this.AcceptedTable = false;
        },
        //get Rejected Table data
        RejectedTableList() {
            this.RejPagecount = 0;
            this.RejectedTable = true;
            this.Shipmentloader = true;
            this.showShipmentsList = [];
            let Filters = {
                cityid: this.RejCityid,
                hubid: this.RejSVCid,
                misroutereason: this.RejMisrouteReason,
                misroutetype: this.RejMisrouteType.toLowerCase(),
                zoneid: this.RejZoneid,
                shipmenttype: this.RejShipmentType,
                currentpincode: this.RejCurrpincode,
                vendorname: this.RejVendorname,
                suggestedhubid: this.RejSuggSVCid,
                clientid: this.RejClientId
            }
            let payload = {
                status: this.status,
                withinsla: this.withinsla.toString(),
                filters: Filters,
                fromdate: this.txtCFDate,
                todate: this.txtCTDate,
                limit: '40',
                pageno: this.rejpageNo,
            }
            if (this.RejAWBNumbers != "") {
                let shipingID = this.RejAWBNumbers.split(/[\s,]+/);
                let shipmentReqArray = [];
                $.each(shipingID, (key, RejAWBNumbers) => {
                    if (RejAWBNumbers != '') {
                        shipmentReqArray.push(RejAWBNumbers.trim())
                    }
                })
                payload.shippingids = shipmentReqArray;
            }
            this.CommonGetTableDetails(payload);
            this.RejectedTable = false;
        },

        getTablePaginationData(pageNum) {
            if (this.ActiveTabIndex == 0) {
                this.UnpageNo = pageNum;
                this.UnassignedTableList();
            }
            if (this.ActiveTabIndex == 1) {
                this.pnpageNo = pageNum;
                this.PendingTableList();
            }
            if (this.ActiveTabIndex == 2) {
                this.accpageNo = pageNum;
                this.AcceptedTableList();
            }
            if (this.ActiveTabIndex == 3) {
                this.rejpageNo = pageNum;
                this.RejectedTableList();
            }
        },

        showMultiShipPopup(reqId) {
            this.getSameReqIdShipments(reqId);
            this.sameReqShipModel = true;
        },
        getSameReqIdShipments(reqId){
            this.MultiShipmentloader = true;
            this.sameVendorShipList = [];
            let Payload = {
              "requestId": reqId
            }
            axios({
              method: 'POST',
              url: apiUrl.api_url + 'misroute/general/getsamerequests/shipments',
              data: Payload
            })
            .then(result => {
              if (result.data.code == 200) {
                this.sameVendorShipList = result.data.data;
              }
              else{
                this.sameVendorShipList = [];
              }
              this.MultiShipmentloader = false;
            })
            .catch((httpException) => {
              this.sameVendorShipList = [];
              this.MultiShipmentloader = false;
              console.error('exception is:::::::::', httpException);
            })
        },

        CloseMoreShipmentModel(){
            this.sameReqShipModel = false;
        },

        BulkAssignFun(){
            this.BulkAssignModel = true;
            this.IsReload = true;
        },
        closeBulkAssignModel(){
            this.UserList = []
            this.User = '';
            this.UserObj = {
                value: "",
                text: ""
            };
            this.BulkAssignModel = false;
            this.BulkAssignButton = false;
            this.BulkActionButton = false;
            this.IsReload = false;
            this.GetUserList();
            this.Reset1()
        },

        BulkActionFun() {
            let removedElement = this.BulkMisrouteinfoArr.shift();
            this.IsReload = true;
            if(this.BulkMisrouteinfoArr.length < 2){
                this.BulkActionButton = false;
                this.$alertify.error("Please select more than one row items to take a bulk action.");
            }
            else if(this.isRTODTO){
                if(!this.Vendorname){
                    this.BulkActionButton = false;
                    this.$alertify.error("Please select Vendor");
                }
                else if(!this.SuggSVCid){
                    this.BulkActionButton = false;
                    this.$alertify.error("Please select Suggested SVC");
                }
                else{
                    // this.BulkActionModel = true;
                    this.SubmitRequestModel = true;
                    this.ReqShipment = removedElement.shippingid;
                    this.ReqShipmentToShow = this.BulkMisrouteinfoArr.length > 1 ? (removedElement.requestid ? (removedElement.requestid + ' and ' + '....') : (removedElement.shippingid + ' and ' + '....')) : (removedElement.requestid ? removedElement.requestid : removedElement.shippingid);
                    this.commonGetShipDetails(removedElement)
                    this.getRejectionReasonByType(this.isRTODTO);
                    // this.getPincodeListAgainstHub();
                }
            }
            else{
                this.IsReload = true;
                if(this.BulkMisrouteinfoArr[0].shipmenttype == 'RTO' || this.BulkMisrouteinfoArr[0].shipmenttype == 'DTO'){
                    this.BulkActionButton = false;
                    this.$alertify.error("Please select ShipmentType, VendorName and SuggestedSVC to continue.!");
                }
                else{
                    this.BulkActionModel = true;
                    this.getRejectionReasonByType(this.isRTODTO);
                }
            }
        },

        selectedItemdataEvent(selectedItems) {
            // console.log("selectedItems:::",JSON.stringify(selectedItems));
            this.IsReload = false;
            this.checkerlistArr = [];
            this.BulkMisrouteinfoArr = [];
            this.ReqShipmentsCount = 0;
            let dummyReqObj = selectedItems[0];
            if(this.SubmitRequestModel != true && selectedItems.length > 1){
                this.BulkMisrouteinfoArr.push(dummyReqObj);
            }

            this.selectedItems = selectedItems;
            let selectedlen = this.selectedItems.length;
            let IsCheckerSelected = false;
            if(selectedlen == 0){
                this.BulkActionButton = false;
                this.BulkAssignButton = false;
                this.AssignButton = false;
                IsCheckerSelected = false;
                this.checkerlistArr = [];
                this.selectedItems = [];
            }
            else if(selectedlen > 0) {
                let assignShipmentList = [];
                let assignCheckerList = [];
                let bulkAssignShipmentList = [];
                let mismatchedTypeShipmentList = [];
                let shipmentTypeofZeroThElement = this.selectedItems[0].shipmenttype;
                let forwardType = ['Delivery','RVP'];
                let reverseType = ['RTO','DTO'];
                let checkShipmentType = forwardType.includes(shipmentTypeofZeroThElement) ? forwardType : reverseType;

                for (let i = 0; i < selectedlen; i++) {
                    this.ReqShipmentsCount += this.selectedItems[i].shipmentcount ? parseInt(this.selectedItems[i].shipmentcount) : 1;
                    let shipmentType = this.selectedItems[i].shipmenttype;
                    let assignShipDetailsObj = {
                        shippingid: this.selectedItems[i].shippingid,
                        shipmenttype: this.selectedItems[i].shipmenttype,
                        requestid: this.selectedItems[i].requestid,
                        currhubid: this.selectedItems[i].currenthubid,
                        currcityid: this.selectedItems[i].currenthubcityid,
                        currpincode: this.selectedItems[i].currentpincode,
                        sugghubid: this.selectedItems[i].suggestedhubid,
                        raisedbyuserid: this.selectedItems[i].raisedbyuserid,
                        vendorname: this.selectedItems[i].vendorname,
                        vendoraddress: this.selectedItems[i].vendoraddress,
                    }
                    bulkAssignShipmentList.push(assignShipDetailsObj);

                    if(checkShipmentType.includes(shipmentTypeofZeroThElement) === checkShipmentType.includes(shipmentType)){
                        //code for bulkAction (accept/Reject)...
                        let selectedShipments = this.selectedItems[i].shippingid;
                        let bulkRequestId = this.selectedItems[i].requestid;
                        let Actualpincode = Number(this.selectedItems[i].suggestedpincode);
                        let MisrouteReason = this.selectedItems[i].misroutereason;
                        let Actualdestinationhubid = this.selectedItems[i].suggestedhubid;
                        let Actualdestinationhub = this.selectedItems[i].suggestedhub;
                        let CurrentHubId = this.selectedItems[i].currenthubid;
                        let RejectionCount = this.selectedItems[i].rejectioncount;
                        let MisrouteCount = this.selectedItems[i].misroutecount;
                        let AssignedHubId = this.selectedItems[i].assigntohubid;
                        let AssignedUserId = this.selectedItems[i].assignedtouserid;
                        //data for logging
                        let currentCity = this.selectedItems[i].currenthubcityid;
                        let currPincode = this.selectedItems[i].currentpincode;
                        let suggHubid = this.selectedItems[i].suggestedhubid;
                        let raisedbyUserid = this.selectedItems[i].raisedbyuserid;
                        let vendorName = this.selectedItems[i].vendorname;
                        let vendorAddress = this.selectedItems[i].vendoraddress;

                        let selectedBulkActionObj = {
                            shippingid: (bulkRequestId == null)? selectedShipments : null,
                            requestid: (bulkRequestId != null)? bulkRequestId : null,
                            shipmenttype: shipmentType,
                            misroutereason: MisrouteReason,
                            actualpincode: Actualpincode,
                            actualdestinationhubid: Actualdestinationhubid,
                            actualdestinationhub: Actualdestinationhub,
                            isservedbygeo: "0",
                            currentHubID: CurrentHubId,
                            rejectioncount: RejectionCount,
                            misroutecount: MisrouteCount,
                            assigntohubid: AssignedHubId,
                            assignedtouserid: AssignedUserId,
                            misrouteLoginfo:{
                                currcityid: currentCity,
                                currpincode: currPincode,
                                sugghubid: suggHubid,
                                raisedbyuserid: raisedbyUserid,
                                vendorname: vendorName,
                                vendoraddress: vendorAddress
                            }
                        };
                        this.BulkMisrouteinfoArr.push(selectedBulkActionObj);
                    }
                    else{
                        mismatchedTypeShipmentList.push(this.selectedItems[i].shippingid);
                    }

                    //condition for checker already selected from table userlist...
                    if(this.selectedItems[i].Checker != null){
                        IsCheckerSelected = true;
                        let shipDetailsObj = {
                            shippingid: this.selectedItems[i].shippingid,
                            shipmenttype: this.selectedItems[i].shipmenttype,
                            requestid: this.selectedItems[i].requestid,
                            currhubid: this.selectedItems[i].currenthubid,
                            currcityid: this.selectedItems[i].currenthubcityid,
                            currpincode: this.selectedItems[i].currentpincode,
                            sugghubid: this.selectedItems[i].suggestedhubid,
                            raisedbyuserid: this.selectedItems[i].raisedbyuserid,
                            vendorname: this.selectedItems[i].vendorname,
                            vendoraddress: this.selectedItems[i].vendoraddress,
                        }
                        assignShipmentList.push(shipDetailsObj);
                        assignCheckerList.push(this.selectedItems[i].Checker);
                    }
                }
                if(IsCheckerSelected==true){
                    this.AssignButton = true;
                    this.selectedShipments = assignShipmentList;
                    for (let i = 0; i < this.selectedShipments.length; i++) {
                        let selectedObj = {
                            "shippingid": this.selectedShipments[i].shippingid,
                            "requestid": this.selectedShipments[i].requestid,
                            "checkerid": assignCheckerList[i],
                            "misrouteLoginfo":{
                                currhubid: this.selectedShipments[i].currhubid,
                                currcityid: this.selectedShipments[i].currcityid,
                                currpincode: this.selectedShipments[i].currpincode,
                                sugghubid: this.selectedShipments[i].sugghubid,
                                raisedbyuserid: this.selectedShipments[i].raisedbyuserid,
                                shipmenttype: this.selectedShipments[i].shipmenttype,
                                vendorname: this.selectedShipments[i].vendorname,
                                vendoraddress: this.selectedShipments[i].vendoraddress,
                            }
                        }
                        this.checkerlistArr.push(selectedObj);
                    }
                }
                else{
                    this.BulkAssignButton = true;
                    this.BulkActionButton = true;
                    this.selectedShipments = bulkAssignShipmentList;
                    for (let i = 0; i < this.selectedShipments.length; i++) {
                        let selectedObj = {
                            "shippingid": this.selectedShipments[i].shippingid,
                            "requestid": this.selectedShipments[i].requestid,
                            "misrouteLoginfo":{
                                currhubid: this.selectedShipments[i].currhubid,
                                currcityid: this.selectedShipments[i].currcityid,
                                currpincode: this.selectedShipments[i].currpincode,
                                sugghubid: this.selectedShipments[i].sugghubid,
                                raisedbyuserid: this.selectedShipments[i].raisedbyuserid,
                                shipmenttype: this.selectedShipments[i].shipmenttype,
                                vendorname: this.selectedShipments[i].vendorname,
                                vendoraddress: this.selectedShipments[i].vendoraddress,
                            }
                        }
                        this.checkerlistArr.push(selectedObj);
                    }
                }
                this.mismatchedTypeShipments = mismatchedTypeShipmentList;
            }
        },

        resetCounts(){
            this.tabWiseShipmentsCount();
            this.withinSLACountAPI();
            this.SLABreachedCountAPI();
            this.Reset();
        },

        //Submit/Assign request to checker
        AssignToChecker() {
            if(this.BulkAssignModel == true && !this.User){
                this.$alertify.error("Please select Checker(user).!");
                return;
            }

            let Payload = {
                // "assigneeuserid": this.userid,
                "checkerlist": this.checkerlistArr,
                "LastModifiedBy":this.createdBy,
            }
            axios({
                method: 'POST',
                url: apiUrl.api_url + 'misroute/assignee/assignchecker',
                data: Payload
            })
            .then(result => {
                if (result.data.code == 200) {
                    // if(this.mismatchedTypeShipments.length > 0){
                    //     this.IsAssignReqSE = true;
                    //     this.dismissCountDown = this.dismissSecs;
                    //     let errorMsg = {'Shipment' : this.mismatchedTypeShipments.toString(), 'message': 'Cannot Assign different type of shipments.'};
                    //     this.mismatchedTypeError = errorMsg;
                    //     this.reqErrorCount = this.mismatchedTypeShipments.length;
                    //     this.reqSuccessCount = this.checkerlistArr.length;
                    // }
                    // else{
                        this.$alertify.success("All Shipments Assigned Successfully!!");
                        this.closeBulkAssignModel();
                    // }
                }
                else if(result.data.code == 400){
                    this.$alertify.error(result.data.message.details[0].message);
                    this.closeBulkAssignModel();
                }
                else {
                    this.$alertify.error(result.data.message);
                    this.closeBulkAssignModel();
                }
                this.resetCounts();
            })
        },

        cancelBulkAssignReq(){
            this.User = '';
            this.UserObj = {
                value: "",
                text: ""
            };
        },

        closeBulkActionModel() {
            // this.UserList = []
            // this.User = '';
            // this.UserObj = {
            //     value: "",
            //     text: ""
            // };
            this.BulkActionButton = false;
            this.BulkAssignButton = false;
            this.BulkActionModel = false;
            this.IsReload = false;
            this.checkerlistArr = [];
            this.selectedItems = [];
            this.AcceptReject = '';
            this.rejectReason = '';
            this.ButtonBulkAction = false;
            this.AssignButton = false;
            this.isRTODTO = (this.ShipmentType == 'RTO/DTO') ? true:false;
            this.ReqShipment = '';
            this.ReqShipmentToShow = '';
            this.BulkSPincode = null;
            this.PincodeListObj = {};
            this.PincodeList = [];
            this.BulkMisrouteinfoArr = [];
            this.requestsErrorMsg= [];
            this.mismatchedTypeError = '';
            this.mismatchedTypeShipments = [];
            this.reqErrorCount= "";
            this.reqSuccessCount= "";
            this.IsAssignReqSE = false;
            this.IsMisrouteReqSE = false;
            this.currentActionTab= '';
            // this.GetUserList();
            this.Reset1()
        },

        //common function to get shipments details from table(row)
        commonGetShipDetails(shipDetails){
            this.ReqShipment = shipDetails.shippingid;
            this.ReqShipmentType = shipDetails.shipmenttype;
            this.isRTODTO = (this.ReqShipmentType == 'RTO' || this.ReqShipmentType == 'DTO') ? true : false;
            this.ReqVendorName = shipDetails.vendorname;
            this.ReqVendorAddress = shipDetails.vendoraddress;
            this.ReqCurrentAddress = shipDetails.currentaddress;
            this.ReqCurrentPincode = shipDetails.currentpincode;
            this.ReqCurrentDestSVC = shipDetails.currenthub;
            this.ReqCurrentHubId = shipDetails.currenthubid;
            this.ReqReason = shipDetails.misroutereason;
            this.ReqsuggSVC = shipDetails.suggestedhub;
            this.ReqsuggHubId = shipDetails.suggestedhubid;
            this.ReqsuggPincode = shipDetails.suggestedpincode;
            this.RejectionCount = shipDetails.rejectioncount;
            this.MisrouteCount = shipDetails.misroutecount;
            this.AssignedHubId = shipDetails.assigntohubid;
            this.AssignedUserId = shipDetails.assignedtouserid;
            this.raisedbyuserid = shipDetails.raisedbyuserid;
            this.ReqCurrentCityId = shipDetails.currenthubcityid;

            if(this.ReqCurrentAddress.includes("&")){
                // this.ReqCurrentAddress.replace("&","and");
                this.ReqCurrentAddress = this.replace(this.ReqCurrentAddress,"&","and");
            }
            this.MapAddress = this.ReqCurrentAddress + " " + (this.ReqsuggPincode ? this.ReqsuggPincode :'');
        },

        takeAction(shipDetails){
            // console.log("shipDetails",JSON.stringify(shipDetails));
            if(shipDetails.raisedbyuserid == this.userid){
                this.$alertify.error('Cannot mark misroute. The requesting user cannot process their own request.');
                return false;
            }

            this.SubmitRequestModel = true;
            this.IsReload = true;
            this.commonGetShipDetails(shipDetails);
            let multiShipmentsReq = (shipDetails.requestid && shipDetails.requestid != null) ? true : false;
            this.ReqShipmentsCount = (shipDetails.shipmentcount && shipDetails.shipmentcount > 0) ? shipDetails.shipmentcount : 0;
            this.ReqShipmentToShow = (multiShipmentsReq && this.ReqShipmentsCount > 0) ? shipDetails.requestid + ' and ' + (this.ReqShipmentsCount) + ' AWBs' : shipDetails.shippingid;
            this.requestId = (multiShipmentsReq && this.ReqShipmentsCount > 0) ? shipDetails.requestid : '';
            this.getRejectionReasonByType(this.isRTODTO);
        },

        replace: function (st, rep, repWith) {
            const result = st.split(rep).join(repWith)
            return result;
        },

        getPincodeListAgainstHub(){
            let Payload = {
                shippingID: this.ReqShipment,
                HubId: this.SuggSVCid
            }
            axios({
                method: 'POST',
                url: apiUrl.api_url + 'shipmentmisroute/pincodeandawbwisehub',
                data: Payload
            })
            .then((response) => {
                if(response.data.code===200){
                    let PincodeArrList = response.data.data.pincodes;
                    for (var i = 0; i < PincodeArrList.length; i++) {
                        this.PincodeList.push({
                            text: `${PincodeArrList[i]}`
                        })
                    }
                }
                else{
                    this.$alertify.error(response.data.message?response.data.message:'No Record found')
                }
            })
        },

        selectPincode(obj){
            this.PincodeListObj = obj;
            this.BulkSPincode = obj.text;
        },

        switchradio(){
            if(this.AcceptReject == '1'){
                this.rejectReason = '';
                this.rejectionReason = '';
            }
            else{
                this.BulkSPincode = null;
                this.PincodeListObj = {};
            }
        },

        selectedOption(){
            if(this.selected == '1'){
                this.rejectionReason = '';
                // this.ActualPincode = this.ReqsuggPincode;
                // this.getPincodeWiseHubForReq();
            }
            if(this.selected == '0') {
                this.ActualDestSVC = '';
                this.ActualPincode = '';
                this.BulkSPincode = null;
                this.PincodeListObj = {};
                this.rejectReason = '';
            }
        },

        getPincodeWiseHubForReq(){
            this.ActualDestSVC = '';
            this.ActualDestHubId = '';
            if(this.ActualPincode && this.selected == '1') {
                this.SVCLoader = this.loader;
                axios.post(apiUrl.api_url + 'misroute/checker/getsvcforlocation', {
                    "shippingid": this.ReqShipment,
                    "pincode": this.ActualPincode,
                    "address": this.ReqCurrentAddress
                })
                .then((response) => {
                    if(response.data.code===200){
                        this.ActualDestSVC = response.data.data.hubName;
                        this.ActualDestHubId = response.data.data.hubId;
                    }
                    else{
                        this.$alertify.error(response.data.message);
                    }
                })
                .catch((httpException) => {
                    this.SVCLoader = false;
                    console.error('exception is:::::::::', httpException)
                })
            }
            else {
                this.$alertify.error('operation failed.!');
            }
            this.SVCLoader = false;
        },

        SubmitMisrouteRequests(){
            let payload = {
                "checkerid": this.userid,
                "LastModifiedBy":this.createdBy,
            };

            if(this.BulkActionModel == true && this.BulkMisrouteinfoArr || (this.SubmitRequestModel == true && this.BulkMisrouteinfoArr.length > 0)){
                payload.isaccept= this.AcceptReject || this.selected;
                if(this.isRTODTO && this.selected == '1'){
                    if(!this.ActualPincode){
                        this.$alertify.error("Please enter correct Pincode");
                        return;
                    }
                    for (let i = 0; i < this.BulkMisrouteinfoArr.length; i++) {
                        this.BulkMisrouteinfoArr[i].actualpincode = this.ActualPincode;
                        this.BulkMisrouteinfoArr[i].actualdestinationhub = this.ActualDestSVC;
                        this.BulkMisrouteinfoArr[i].actualdestinationhubid = this.ActualDestHubId;
                        // if(this.BulkMisrouteinfoArr[i].actualpincode == 0 || this.BulkMisrouteinfoArr[i].actualpincode == null){
                        //     if(this.BulkSPincode == null && (this.AcceptReject == '1' || this.selected == '1')){
                        //         this.$alertify.error("Please select Pincode");
                        //         return;
                        //     }
                        //     this.BulkMisrouteinfoArr[i].actualpincode = this.BulkSPincode;
                        // }
                    }
                }
                payload.misrouteinfo = this.BulkMisrouteinfoArr;
                // payload.isBulkAction = true;
                if((this.AcceptReject == 0 && this.rejectReason == '' && !this.isRTODTO)||(this.selected == 0 && this.rejectionReason == '' && this.isRTODTO)){
                    this.$alertify.error("Please enter rejection reason");
                    return;
                }
                if((this.AcceptReject == 0 || this.selected == 0) && (this.rejectReason != '' || this.rejectionReason != '')){
                    for(let i = 0 ; i < payload.misrouteinfo.length; i++){
                        delete payload.misrouteinfo[i].actualpincode;
                        delete payload.misrouteinfo[i].actualdestinationhub;
                        delete payload.misrouteinfo[i].actualdestinationhubid;
                    }
                    payload.rejectreason = this.rejectReason || this.rejectionReason;
                }
                this.commonSubmitAPICall(payload);
            }
            else if(this.SubmitRequestModel == true && this.BulkMisrouteinfoArr.length == 0){
                payload.isaccept= this.selected;
                // payload.isBulkAction = false;

                let reqMisrouteObj = {
                    shippingid: (!this.requestId) ? this.ReqShipment : null,
                    requestid: (this.requestId)? this.requestId : null,
                    shipmenttype: this.ReqShipmentType,
                    misroutereason: this.ReqReason,
                    actualpincode: this.ActualPincode,
                    actualdestinationhubid: this.ActualDestHubId,//from geo api or pcms will need,
                    actualdestinationhub: this.ActualDestSVC,
                    isservedbygeo: "0",
                    currentHubID: this.ReqCurrentHubId,
                    rejectioncount: this.RejectionCount,
                    misroutecount: this.MisrouteCount,
                    assigntohubid: this.AssignedHubId,
                    assignedtouserid: this.AssignedUserId,
                    misrouteLoginfo:{
                        currcityid: this.ReqCurrentCityId,
                        currpincode: this.ReqCurrentPincode,
                        sugghubid: this.ReqsuggHubId,
                        raisedbyuserid: this.raisedbyuserid,
                        vendorname: this.ReqVendorName,
                        vendoraddress: this.ReqVendorAddress,
                    }
                }

                if(!reqMisrouteObj.actualdestinationhubid && !reqMisrouteObj.actualpincode && this.selected == '1' && this.ReqsuggPincode){
                    let message = {
                        title: `<center><p>Confirmation</p></center>`,
                        body: `<center><p>Do you want to continue with </p>
                        <p>SuggestedPincode & SuggestedHub as Actual Values?</p></center>`,
                    };
                    this.$dialog.confirm(message, {
                        html: true,
                        animation: 'bounce',
                        backdropClose: true,
                        okText: 'Yes',
                        cancelText: 'No',
                        reverse: true,
                        loader: true
                    })
                    .then(dialog=>{
                        if(this.ReqsuggPincode){
                            this.ActualPincode = this.ReqsuggPincode;
                            this.ActualDestSVC = this.ReqsuggSVC;
                            this.ActualDestHubId = this.ReqsuggHubId
                        }
                        reqMisrouteObj.actualdestinationhubid = this.ReqsuggHubId;
                        reqMisrouteObj.actualpincode = this.ReqsuggPincode;
                        reqMisrouteObj.actualdestinationhub = this.ReqsuggSVC,

                        payload.misrouteinfo = [reqMisrouteObj];
                        this.commonSubmitAPICall(payload);
                        dialog.close();
                    })
                }
                else{
                    if(this.selected == '1' && !this.ActualPincode){
                        this.$alertify.error('Please enter valid Pincode.');
                        return;
                    }
                    if(this.selected == 0 && this.rejectionReason == ''){
                        this.$alertify.error("Please enter rejection reason");
                        return;
                    }
                    if(this.selected == 0){
                        payload.rejectreason = this.rejectionReason;
                        delete reqMisrouteObj.actualpincode;
                        delete reqMisrouteObj.actualdestinationhub;
                        delete reqMisrouteObj.actualdestinationhubid;
                    }
                    payload.misrouteinfo = [reqMisrouteObj];
                    this.commonSubmitAPICall(payload);
                }
            }
        },

        commonSubmitAPICall(payload){
            this.submitLoader = true;
            axios({
                method: 'POST',
                url: apiUrl.api_url + 'misroute/checker/submitaction',
                data: payload
            })
            .then(result => {
                if (result.data.code == 200) {
                    if(this.mismatchedTypeShipments.length > 0){
                        this.IsMisrouteReqSE = true;
                        this.dismissCountDown = this.dismissSecs;
                        let errorMsg = {'Shipment' : this.mismatchedTypeShipments.toString(), 'message': 'Cannot take Bulk Action on different type of shipments.'};
                        this.mismatchedTypeError = errorMsg;
                        this.reqErrorCount = this.mismatchedTypeShipments.length;
                        this.reqSuccessCount = this.BulkMisrouteinfoArr.length;
                    }
                    else{
                        this.$alertify.success(result.data.message);
                        this.closeBulkActionModel();
                        this.closeSubmitRequestModel();
                        if(this.withinsla == '1'){
                            this.GetCurrentScreenValue('WithinSLA');
                        }
                        else if(this.withinsla == '0'){
                            this.GetCurrentScreenValue('SLABreached');
                        }
                    }
                }
                else if(result.data.code == 204){
                    if(this.BulkActionModel == true || (this.SubmitRequestModel == true && this.BulkMisrouteinfoArr.length > 0 && this.isRTODTO) || (this.SubmitRequestModel == true && this.requestId && this.isRTODTO)){
                        this.IsMisrouteReqSE = true;
                        this.dismissCountDown = this.dismissSecs;
                        this.requestsErrorMsg = result.data.errorMessage;
                        let errorsCount = result.data.errorMessage.length;
                        let successCount = this.ReqShipmentsCount - result.data.errorMessage.length;
                        if(this.mismatchedTypeShipments.length > 0){
                            let errorMsg = {'Shipment' : this.mismatchedTypeShipments.toString(), 'message': 'Cannot take Bulk Action on different type of shipments.'};
                            this.mismatchedTypeError = errorMsg;
                            this.reqErrorCount = errorsCount + this.mismatchedTypeShipments.length;
                            this.reqSuccessCount = successCount;
                        }
                        else{
                            this.requestsErrorMsg = result.data.errorMessage;
                            this.reqErrorCount = errorsCount;
                            this.reqSuccessCount = successCount;
                        }
                    }
                    if(this.SubmitRequestModel == true && this.BulkMisrouteinfoArr.length == 0 && !this.requestId){
                        this.$alertify.error(result.data.errorMessage[0].message);
                    }
                }
                else{
                    if(!this.ActualPincode && this.selected == '1'){
                        this.$alertify.error('Please enter valid Pincode.');
                    }
                    else{
                        this.$alertify.error(result.data.message.details[0].message);
                    }
                }
                this.submitLoader = false;
                this.resetCounts();
            }, error => {
                this.submitLoader = false;
                console.error(error)
            })
        },

        cancelBulkActionReq(){
            this.AcceptReject = '';
            this.rejectReason = '';
            this.requestsErrorMsg= [];
            this.mismatchedTypeError = ''
            this.reqErrorCount= "";
            this.reqSuccessCount= "";
            this.BulkSPincode = null;
            this.PincodeListObj = {};
        },

        closeSubmitRequestModel(){
            this.IsReload = true;
            this.SubmitRequestModel = false;
            this.BulkMisrouteinfoArr = [];
            this.ReqShipmentToShow = '';
            this.ReqShipmentsCount = 0;
            this.reqErrorCount= "";
            this.reqSuccessCount= "";
            this.IsMisrouteReqSE = false;
            this.MapAddress = '';
            this.isRTODTO = false;
            this.cancelReq();
            this.Reset1()
        },

        resetFiltersAndGetData(){
            if(this.SVCid)
                this.GetSVCList();
            if(this.Zoneid)
                this.GetZoneList();
            if(this.Cityid)
                this.loadCityList();
            if(this.Vendorname)
                this.GetVendorList();
            if(this.Currpincode)
                this.GetCurrentPincodeList();
            if(this.SuggSVCid)
                this.GetSuggSVCList();
            if(this.ClientId)
                this.getRequestedClientIdsList();
            this.UnassignedTableList();
        },

        cancelReq(){
            this.IsReload = false;
            this.selected = '';
            this.ActualDestSVC = '';
            this.ActualPincode = '';
            this.ActualDestHubId = '';
            this.rejectionReason = '';

            //reset bulk action attributes
            this.BulkSPincode = null;
            this.PincodeListObj = {};
            this.rejectReason = '';

            this.$validator.reset();
            this.errors.clear();
        },

        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },

        Reset() {
            this.checkerlistArr = [];
            this.selectedItems = [];
            this.City = '';
            this.CityObj = {
                value: "",
                text: ""
            };
            this.Cityid = '';
            this.SVC = '';
            this.SVCObj = {
                value: "",
                text: ""
            },
            this.SuggSVCObj = {
                value: "",
                text: ""
            },
            this.SuggSVC = '';
            this.SuggSVCid = '';
            this.MisrouteType = '';
            this.MisroutetypeObj = {};
            this.ShipmentType = '';
            this.PendingShipmentType = '';
            this.AccShipmentType = '';
            this.RejShipmentType = '';
            this.Currpincode = '',
            this.PendingCurrpincode = '',
            this.AccCurrpincode = '',
            this.RejCurrpincode = '',
            this.Vendorname = '',
            this.PendingVendorname = '',
            this.AccVendorname = '',
            this.RejVendorname = '',
            this.CurrpincodeObj = {text: ""};
            this.VendornameObj = {text: ""};
            // this.ClientId = '',
            // this.PendingClientId = '',
            // this.AccClientId = '',
            // this.RejClientId = '',
            // this.reqClientObj = {};
            this.CurrpincodeObj = {text: ""};
            this.ShipmentTypeObj = {};
            this.MisrouteReason = '';
            this.MisrouteReasonObj = {};
            this.Zone = '';
            this.ZoneObj = {
                value: "",
                text: ""
            },
            this.AWBNumbers = '';
            this.PendingAWBNumbers = '';
            this.AccAWBNumbers = '';
            this.RejAWBNumbers = '';
            this.txtCFDate = null;
            this.txtCTDate = null;
            this.User = ''
            this.UserObj = {
                value: "",
                text: ""
            };
            this.PendingMisrouteType = '';
            this.AccMisrouteType = '';
            this.RejMisrouteType = '';
            this.PendingMisrouteReason = '';
            this.AccMisrouteReason = '';
            this.RejMisrouteReason = '';
            this.PendingCity = '';
            this.PendingCityid = '';
            this.AccCity = '';
            this.AccCityid = '';
            this.RejCity = '';
            this.RejCityid = '';
            this.PendingSVC = '';
            this.AccSVC = '';
            this.RejSVC = '';
            this.PendingZone = '';
            this.PendingZoneid = '';
            this.Zoneid = '';
            this.AccZone = '';
            this.AccZoneid = '';
            this.RejZone = '';
            this.RejZoneid = '';
            this.User = '';
            this.SVCid = '';
            this.PendingSVCid = '';
            this.AccSVCid = '';
            this.RejSVCid = '';
            this.AssignButton = false;
            this.BulkActionButton = false;
            this.currentFiltersTab = 'clearFilters',
            this.IsReload = true;
            this.isRTODTO = false;
            this.tabWiseGetAndSearchData();
        },
        Reset1() {
            this.checkerlistArr = [];
            this.selectedItems = [];
            this.City = '';
            this.CityObj = {
                value: "",
                text: ""
            };
            this.Cityid = '';
            this.SVC = '';
            this.SVCObj = {
                value: "",
                text: ""
            },
            this.SuggSVCObj = {
                value: "",
                text: ""
            },
            this.SuggSVC = '';
            this.SuggSVCid = '';
            this.ShipmentType = '';
            this.PendingShipmentType = '';
            this.AccShipmentType = '';
            this.RejShipmentType = '';
            this.Currpincode = '',
            this.PendingCurrpincode = '',
            this.AccCurrpincode = '',
            this.RejCurrpincode = '',
            this.Vendorname = '',
            this.PendingVendorname = '',
            this.AccVendorname = '',
            this.RejVendorname = '',
            // this.ClientId = '',
            // this.PendingClientId = '',
            // this.AccClientId = '',
            // this.RejClientId = '',
            // this.reqClientObj = {};
            this.CurrpincodeObj = {text: ""};
            this.VendornameObj = {text: ""};
            this.ShipmentTypeObj = {};
            this.MisrouteType = '';
            this.MisroutetypeObj = {};
            this.MisrouteReason = '';
            this.MisrouteReasonObj = {};
            this.Zone = '';
            this.ZoneObj = {
                value: "",
                text: ""
            },
            this.AWBNumbers = '';
            this.PendingAWBNumbers = '';
            this.AccAWBNumbers = '';
            this.RejAWBNumbers = '';
            this.txtCFDate = null;
            this.txtCTDate = null;
            this.User = ''
            this.UserObj = {
                value: "",
                text: ""
            };
            this.PendingMisrouteType = '';
            this.AccMisrouteType = '';
            this.RejMisrouteType = '';
            this.PendingMisrouteReason = '';
            this.AccMisrouteReason = '';
            this.RejMisrouteReason = '';
            this.PendingCity = '';
            this.PendingCityid = '';
            this.AccCity = '';
            this.AccCityid = '';
            this.RejCity = '';
            this.RejCityid = '';
            this.PendingSVC = '';
            this.AccSVC = '';
            this.RejSVC = '';
            this.PendingZone = '';
            this.PendingZoneid = '';
            this.Zoneid = '';
            this.AccZone = '';
            this.AccZoneid = '';
            this.RejZone = '';
            this.RejZoneid = '';
            this.User = '';
            this.SVCid = '';
            this.PendingSVCid = '';
            this.AccSVCid = '';
            this.RejSVCid = '';
            this.AssignButton = false;
            this.BulkActionButton = false;
            this.isRTODTO = false;
            this.currentFiltersTab = 'clearFilters'
        },
        resetAllDropDowns(){
            this.AccClientId = '',
            this.RejClientId = '',
            this.reqClientObj = {};
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/components/MisrouteRequestAssignee/MisrouteRequestAssignee.component.js